define('presentation/settings/liveReceptionistScripts/viewModels/reactivateLiveReceptionistScriptModalViewModel',[
    'common/promises/promiseFactory',
    'common/url/urlFormatter'
], function() {
    return function (liveReceptionistScript) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _urlFormatter = require('common/url/urlFormatter');

        self.liveReceptionistScript = liveReceptionistScript;
        self.pricingUrl = _urlFormatter.buildFrontendUrl(["pricing"]);

        self.activate = () => {

            return _initialize();
        };

        const _initialize = () => {

            return _promiseFactory.wait();
        };
    };
});

